import React from 'react';
import { CheckCircleIcon, XCircleIcon, ClockIcon, ChartBarIcon } from '@heroicons/react/24/outline';

interface ResultsStatsProps {
  stats: {
    totalQuestions: number;
    correctAnswers: number;
    wrongAnswers: number;
    accuracy: number;
    totalTimeSpent: number;
    averageTimePerQuestion: number;
  };
}

export const ResultsStats: React.FC<ResultsStatsProps> = ({ stats }) => {
  const formatTime = (milliseconds: number) => {
    // Gestisci il caso NaN o valori non validi
    if (!milliseconds || isNaN(milliseconds) || milliseconds < 0) {
      return '0m 0s';
    }
    
    const seconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}m ${remainingSeconds}s`;
  };

  // Usa totalTimeSpent dal backend (in millisecondi)
  const totalTime = stats.totalTimeSpent || 0;
  
  // Debug per capire i valori delle statistiche
  console.log('📊 [DEBUG] Stats ricevute:', {
    totalTimeSpent: stats.totalTimeSpent,
    timeSpent: (stats as any).timeSpent,
    finalTotalTime: totalTime,
    isNaN: isNaN(totalTime),
    stats: stats
  });

  return (
    <div 
      className="grid gap-2 mb-2"
      style={{
        gridTemplateColumns: 'repeat(2, 1fr)',
        display: 'grid'
      }}
    >
      {/* Precisione */}
      <div className="card text-center py-2">
        <div className="w-8 h-8 bg-success-100 rounded-lg flex items-center justify-center mx-auto mb-1">
          <ChartBarIcon className="h-4 w-4 text-success-600" />
        </div>
        <p className="text-lg font-bold text-gray-900">{stats.accuracy.toFixed(1)}%</p>
        <p className="text-xs text-gray-600">Precisione</p>
      </div>

      {/* Risposte Corrette */}
      <div className="card text-center py-2">
        <div className="w-8 h-8 bg-success-100 rounded-lg flex items-center justify-center mx-auto mb-1">
          <CheckCircleIcon className="h-4 w-4 text-success-600" />
        </div>
        <p className="text-lg font-bold text-gray-900">{stats.correctAnswers}</p>
        <p className="text-xs text-gray-600">Corrette</p>
      </div>

      {/* Risposte Sbagliate */}
      <div className="card text-center py-2">
        <div className="w-8 h-8 bg-danger-100 rounded-lg flex items-center justify-center mx-auto mb-1">
          <XCircleIcon className="h-4 w-4 text-danger-600" />
        </div>
        <p className="text-lg font-bold text-gray-900">{stats.wrongAnswers}</p>
        <p className="text-xs text-gray-600">Sbagliate</p>
      </div>

      {/* Tempo Totale */}
      <div className="card text-center py-2">
        <div className="w-8 h-8 bg-accent-100 rounded-lg flex items-center justify-center mx-auto mb-1">
          <ClockIcon className="h-4 w-4 text-accent-600" />
        </div>
        <p className="text-lg font-bold text-gray-900">{formatTime(totalTime)}</p>
        <p className="text-xs text-gray-600">Tempo Totale</p>
      </div>
    </div>
  );
};
